import type { dashboard as pt } from '../pt/dashboard';
// English mirror of ../pt/dashboard.ts (shape checked against its pt twin).
export const dashboard: typeof pt = {
  title: 'Dashboard',
  subtitle: 'Overview of collaborators and contracts',
  viewPeople: 'View collaborators',
  loading: 'Loading…',
  welcome: {
    morning: 'Good morning',
    afternoon: 'Good afternoon',
    evening: 'Good evening',
    named: '{greeting}, {name}',
    pending: '{count} registration requests to handle.',
    allClear: 'No registration requests to handle.',
    review: 'Review requests',
  },
  kpi: {
    active: 'Total Active',
    doctorate: 'Total Doctorate Holders',
    adminServices: 'Total Administrative Services',
    pending: 'Pending requests',
  },
  charts: {
    last12Months: 'last 12 months',
    started: {
      title: 'Contracts started',
      aria: 'Contracts started per month over the last 12 months',
    },
    ended: {
      title: 'Contracts ended',
      aria: 'Contracts ended per month over the last 12 months',
    },
    yearCompare: {
      title: 'Previous vs current year',
      subtitle: 'contracts started',
      aria: 'Comparison of contracts started: previous year vs current year with forecast',
    },
  },
  legend: {
    previousYear: 'Previous year',
    currentYear: 'Current year',
    forecast: 'Forecast',
  },
  custom: {
    heading: 'Custom indicators',
    pubsByYear: 'Publications by year',
    pubsByMonth: 'Publications by month (current year)',
    distribution: 'Distribution of collaborators by field',
    citationsByYear: 'Citations by year',
    quartileDist: 'Distribution of publications by quartile',
    pubsByTeam: 'Publications by team',
    topResearchers: 'Top researchers by publications',
    yearCompareAria: 'Contracts started: previous year vs current year with forecast',
    pubsYearCompareAria: 'Publications: previous year vs current year with forecast',
    contractsByMonth: 'Contracts per month over the last 12 months',
  },
  pending: {
    title: 'Pending requests',
    empty: 'No pending requests. 🎉',
  },
  customize: {
    edit: 'Customize',
    done: 'Done',
    reset: 'Reset to default',
    addTitle: 'Add to dashboard',
    allAdded: 'All cards are already on the dashboard.',
    dragHint: 'Drag to reorder',
    empty: 'Your dashboard is empty. Use "Customize" to add cards.',
    size: {
      sm: 'Small',
      md: 'Medium',
      lg: 'Large',
    },
  },
  table: {
    name: 'Name',
    email: 'Email',
    department: 'Department',
    received: 'Received',
    status: 'Status',
  },
};
